import React from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

export default function ErrorPage() {

  const user = useSelector((state) => state.AuthSlice.user);

  const navigate = useNavigate()

  const handleGoOnHome = () => {
    navigate('/');
    setTimeout(() => {
      window.location.reload();
    }, 0);
  };

  return (
    <>
      <div className="col-md-12 sample-pages-box">
        <div>
          <div className="subscripiton-plans-box subscription-height-box-main">
            <div className="container h-100">
              <div className="row h-100">
                <div className="col-md-12 mb-4 h-100">
                  <div className="subscription-card">
                    <div className="about-text-box thank-you-text-content failed-model-box">
                      <div className="thank-you-tick-icon">
                        <i className="fa-solid fa-xmark"></i>
                      </div>

                      <h2 className="mt-0">
                        Payment Failed!
                      </h2>
                      <p
                        className="common-text"
                        style={{ textTransform: "capitalize" }}
                      >
                        Unfortunately, your payment could not be processed. Please check your payment details and try again. If the issue persists, contact support for assistance.
                      </p>

                      <a onClick={handleGoOnHome} className="btn btn-danger">
                        Go Back to Home
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
